"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const Amex = (props) => {
    const { width, height, color } = props;
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height, viewBox: "0 0 70 70" },
        react_1.default.createElement(react_native_svg_1.Path, { fill: color, d: "M48.6,24.3l1.4-3.7h6.2v-6.7H13.8v42.4h42.4v-6.7h-5.9l-2.2-2.5l-2.2,2.5H29.3V36.2h-5.5l6.9-15.5h6.7l1.6,3.5 v-3.5h8.3L48.6,24.3L48.6,24.3z M44,26.8v-1.5l0.6,1.5l2.8,7.4H50l2.8-7.4l0.5-1.5v8.8h2.9V22.8h-4.8l-2.2,5.7l-0.6,1.6L48,28.5 l-2.2-5.7H41v11.3h3V26.8L44,26.8z M37.8,34.1h3.3l-5-11.3h-3.9l-5,11.3h3.3l0.9-2.2h5.5L37.8,34.1L37.8,34.1z M33.6,26.7l0.6-1.4 l0.6,1.4l1.2,2.9h-3.5L33.6,26.7L33.6,26.7z M31.6,36.2v11.3H41v-2.4h-6.6v-2h6.4v-2.4h-6.4v-2H41v-2.4L31.6,36.2L31.6,36.2z M51.6,47.4h3.7L50,41.8l5.3-5.6h-3.7l-3.4,3.7l-3.4-3.7H41l5.3,5.7L41,47.5h3.6l3.4-3.7L51.6,47.4L51.6,47.4z M53,41.8l3.2,3.3 v-6.5L53,41.8L53,41.8z" })));
};
Amex.defaultProps = {
    color: '#006FCF',
    width: 24,
    height: 24,
};
exports.default = react_1.default.memo(Amex);
